import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Message } from 'antd';
import { fetchOCR } from '../../api/demonstration';
import FunctionDemonstration from './FunctionDemonstration';
import account from '@/common/account/index';

const OcrHrDemonstration = ({ materialsPath, selectList }) => {
  const [result, setResult] = useState(null);
  const [response, setReponse] = useState(null);
  const [request] = useState({
    Params: {
      picture: '图片的Base64编码',
      url: '图像地址'
    }
  });

  const identifyingImg = (imgUrl, picture) => {
    let imgBase64 = '';
    if (picture) {
      imgBase64 = picture.replace(/\S*base64,/, '');
    }
    let userId = null;
    const loginEd = account.hasLoggedin();
    if (loginEd) userId = localStorage.getItem('userId') || null;
    fetchOCR({
      image_url: imgUrl,
      image_base64: imgBase64,
      method: '/aiocr/chart-recognition',
      userId
    })
      .then((data) => {
        setReponse(data);
        if (data.code === 20000) {
          const res = data.data;
          setResult(res);
        } else {
          throw new Error('识别失败');
        }
      })
      .catch((err) => {
        if (err.code == 300043104) {
          Message.error('图像分辨率不支持');
        } else {
          Message.error(err.msg || err.message);
        }
        setReponse({});
      });
  };

  const getCell = (row, line, cell_info) => {
    for (let index = 0; index < cell_info.length; index++) {
      if (
        cell_info[index].start_row == row &&
        cell_info[index].start_line == line
      ) {
        return cell_info[index];
      }
    }
  };

  const sortCell = (origin) => {
    const sortedList = [];
    for (let row = 0; row <= origin.max_row_num; row++) {
      for (let line = 0; line <= origin.max_line_num; line++) {
        const cell = getCell(row, line, origin.cell_info);
        if (typeof cell == 'object') {
          sortedList.push(cell);
        }
      }
    }
    return sortedList;
  };

  let sortedCells = [];
  if (result) {
    sortedCells = sortCell(result);
  }

  return (
    <FunctionDemonstration
      result={
        <ul>
          <a
            href={result ? result.url_excel : ''}
            style={{ marginLeft: '20px' }}
          >
            识别结果Excel下载
          </a>
          {sortedCells.map((resultItem, index) => {
            return (
              // eslint-disable-next-line react/no-array-index-key
              <li key={resultItem.content + index} className="result_text">
                <span>{index + 1}:</span>
                <span>{resultItem.content}</span>
              </li>
            );
          })}
        </ul>
      }
      response={response}
      request={request}
      handleIdentifyingImg={identifyingImg}
      materialsPath={materialsPath}
      selectList={selectList}
    />
  );
};

OcrHrDemonstration.propTypes = {
  data: PropTypes.shape({
    materialsPath: PropTypes.array,
    selectList: PropTypes.array
  })
};

export default OcrHrDemonstration;
